<template>
    <div class="hts-company-info">
        <div class="flex items-center justify-start p-3">
            <hi-arrow-left-icon
                class="icon w-10 font-bold cursor-pointer hover:bg-gray-200"
                @click="handleGoBack" />
            <h3 class="text-xl font-bold ml-2">
                {{ `Chi nhánh ${companyBranchInfo.name}` }}
            </h3>
        </div>
        <div class="mb-3 text-right pr-4">
            <hts-form-button
                v-if="group.isAdmin || permissions.includes('company_branch_banking_add')"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="handleCreateBanking">
                {{ $t('labels.addBanking') }}
            </hts-form-button>
        </div>
        <div
            v-for="(item, index) in bankingList.value"
            :key="index">
            <div class="hts-company-group-ignore-add-group">
                <div class="hts-company-group-ignore-add-group__container-body">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ `Ngân hàng ${index + 1}` }}
                                </span>
                            </h3>
                        </template>
                        <template
                            v-if="group.isAdmin || permissions.includes('company_branch_banking_edit') || permissions.includes('company_branch_banking_delete')"
                            #toolbar>
                            <hts-dropdown
                                :options="dropdownOptions"
                                type="text"
                                :label-only-icon="true"
                                color="theme"
                                size="large"
                                prop-option-key="id"
                                prop-option-label="name"
                                icon="hi-ellipsis-vertical-icon"
                                prop-option-icon="hi-pencil-alt-icon"
                                @click="(action) => handleClick(action, item, index)" />
                        </template>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                            <div>
                                <h3>
                                    {{ $t('labels.bankingName') }}
                                </h3>
                                <p class="mt-2">
                                    {{ item.bankingName }}
                                </p>
                            </div>
                            <div>
                                <h3>
                                    {{ $t('labels.bankingBranch') }}
                                </h3>
                                <p class="mt-2">
                                    {{ item.bankingBranch }}
                                </p>
                            </div>
                            <div>
                                <h3>
                                    {{ $t('labels.accountNumber') }}
                                </h3>
                                <p class="mt-2">
                                    {{ item.bankingAccountNumber }}
                                </p>
                            </div>
                            <div>
                                <h3>
                                    {{ $t('labels.accountName') }}
                                </h3>
                                <p class="mt-2">
                                    {{ item.accountHolderName }}
                                </p>
                            </div>
                        </div>
                    </hts-card>
                </div>
            </div>
        </div>
        <add-banking
            :show="showSlideOverAddBanking"
            :size-slide-over="30"
            :company-branch="companyBranchInfo"
            @close="showSlideOverAddBanking = false"
            @refresh="(newBanking:Object)=>handleRefresh(newBanking)" />
        <edit-banking
            :show="showSlideOverEditBanking"
            :size-slide-over="30"
            :company-branch="companyBranchInfo"
            :banking-is-selected-to-edit="bankingIsSelectedToEdit"
            :banking-index="(BankingIndex as number)"
            @update="(updatedData:Object,index:number)=>handleUpdate(updatedData,index)"
            @close="showSlideOverEditBanking = false"
            @refresh="(newBanking:Object)=>handleRefresh(newBanking)" />
        <hts-modal
            :show="showPopupDelete"
            :title="$t('labels.deleteBanking')"
            type="confirm"
            :content="$t('notifications.confirmDeleteBanking')"
            @close="closePopupDelete"
            @confirm="handleDelete" />
        <hts-modal
            :show="checkEmptyData"
            :title="$t('notifications.emptyData')"
            type="confirm"
            :is-show="false"
            :content-button-confirm="$t('labels.addBanking')"
            @confirm="handleCreateBanking"
            @hide="checkEmptyData = false" />
    </div>
</template>

<script setup lang="ts">
import AddBanking from './add-banking.vue'
import EditBanking from './edit-banking-branch.vue'
import { IBankingInformation } from './imports/banking-form'
import companyPageTabs from '@/data/company/tabs.json'

const route = useRoute()
const store = $store()
const group = store.system.getGroup
const permissions = ref<Array<String>>([])
const dropdownOptions = ref<Array<Object>>([])
onMounted(() => {
  permissions.value = group.permissions
  dropdownOptions.value =
    group.isAdmin || (permissions.value.includes('company_branch_banking_edit') && permissions.value.includes('company_branch_banking_delete'))
      ? [
        {
          id: 1,
          name: `${$t('labels.edit')}`,
          icon: 'hi-pencil-alt-icon',
          action: 'edit'
        },
        {
          id: 2,
          name: `${$t('labels.delete')}`,
          icon: 'hi-pencil-alt-icon',
          action: 'delete'
        }
      ]
      : group.isAdmin || permissions.value.includes('company_branch_banking_edit')
        ? [
          {
            id: 1,
            name: `${$t('labels.edit')}`,
            icon: 'hi-pencil-alt-icon',
            action: 'edit'
          }
        ]
        : [
          {
            id: 2,
            name: `${$t('labels.delete')}`,
            icon: 'hi-pencil-alt-icon',
            action: 'delete'
          }
        ]
})
// const dropdownOptions = group.isAdmin || permissions.value.includes('company_branch_banking_edit')
//   ? [
//     {
//       id: 1,
//       name: `${$t('labels.edit')}`,
//       icon: 'hi-pencil-alt-icon',
//       action: 'edit'
//     }
//   ]
//   : group.isAdmin || permissions.value.includes('company_branch_banking_delete')
//     ? [
//       {
//         id: 2,
//         name: `${$t('labels.delete')}`,
//         icon: 'hi-pencil-alt-icon',
//         action: 'delete'
//       }
//     ]
//     : [
//       {
//         id: 1,
//         name: `${$t('labels.edit')}`,
//         icon: 'hi-pencil-alt-icon',
//         action: 'edit'
//       },
//       {
//         id: 2,
//         name: `${$t('labels.delete')}`,
//         icon: 'hi-pencil-alt-icon',
//         action: 'delete'
//       }
//     ]

onBeforeMount(() => {
  route.meta.pageTabs = companyPageTabs
})
const props = defineProps({
  bankingIsSelectedToView: {
    type: Array,
    default: () => []
  },
  companyBranch: {
    type: Object,
    default: () => {}
  }
})
const { bankingIsSelectedToView, companyBranch } = toRefs(props)
const bankingIsSelectedToEdit = reactive<IBankingInformation>({
  bankingName: '',
  bankingAccountNumber: '',
  bankingBranch: '',
  accountHolderName: ''
})
const bankingIsSelectedToDelete = reactive<IBankingInformation>({
  bankingName: '',
  bankingAccountNumber: '',
  bankingBranch: '',
  accountHolderName: ''
})
const bankingList: any = reactive({ value: [] })
const companyBranchInfo: { [key: string]: any } = reactive({})
const showSlideOverAddBanking = ref(false)
const showSlideOverEditBanking = ref(false)
const showPopupDelete = ref(false)
const BankingIndex = ref<Number>(0)
const deleteBankingIndex = ref<Number>(0)
const checkEmptyData = ref(false)
onMounted(() => {
  bankingList.value = bankingIsSelectedToView.value
  if (bankingList.value.length === 0) {
    checkEmptyData.value = true
  }
  Object.assign(companyBranchInfo, companyBranch.value)
})
const emits = defineEmits(['back'])
const handleCreateBanking = () => {
  checkEmptyData.value = false
  showSlideOverAddBanking.value = true
}
const handleClick = (action: string, data: Object, index: Number) => {
  if (!action) {
    return null
  }
  switch (action) {
  case 'edit':
    handleEditBanking(data, index)
    break
  case 'delete':
    deleteBankingIndex.value = index
    showPopupDelete.value = true
    break
  default:
    break
  }
}
const closePopupDelete = () => {
  showPopupDelete.value = false
  Object.assign(bankingIsSelectedToDelete, {})
}
const handleEditBanking = (banking: Object, index: Number) => {
  Object.assign(bankingIsSelectedToEdit, banking)
  BankingIndex.value = index
  showSlideOverEditBanking.value = true
}
const handleDelete = () => {
  const api = $url.companyBranch.deleteBanking
  const deleteBanking = bankingList.value[deleteBankingIndex.value as number]
  $api(api, { body: { id: companyBranchInfo._id, bankingId: deleteBanking._id } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        bankingList.value.splice(deleteBankingIndex.value, 1)
        process.client && $toast().success($t('notifications.deleteBankingSuccess'))
        closePopupDelete()
      }
    })
    .catch((error: any) => error)
}
const handleUpdate = (data: Object, index: number) => {
  bankingList.value[index] = { ...bankingList.value[index], ...data }
}
const handleGoBack = () => {
  emits('back')
}
const handleRefresh = (newBanking: Object) => {
  if (!newBanking) {
    return true
  }
  bankingList.value.push({ ...newBanking, _id: 123 })
}
</script>
